import { SettingsFooter, STATUS_TYPES, Notification } from "dyl-components";
import {Icon, Popup, List, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import React, { useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from 'actions/axiosInstance';
import './index.scss';

export const ImportFooter = ({
    isMinimumFields,
    currentStep,
    goToNextStep,
    isNextStepEnabled,
    STEPS,
    goToPreviousStep,
    width = "100%",
    upload_id,
    customStep
}) => {
    const [isErrApiLoading, setIsErrApiLoading] = useState(false);
    const { import_results, isAddingImport } = useSelector(state => state.import_data);

    const downloadCSV = (csvString) => {
        try {
            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } catch (error) {
            console.error("Error downloading CSV:", error);
            Notification.alert("Failed to download CSV file", STATUS_TYPES.ERROR, true);
        }
    };
    
    const downloadErrfile = async () => {
        setIsErrApiLoading(true);
        return await axiosInstance.lead_ingestion_instance.get(
            `/v1/download/${upload_id}/errors`,
            {
                headers: {
                    "authorization": (await axiosInstance.instance1.get(`/v1/jwt`)).data.token,
                    accept:''
                },
            }
        ).then((response) => {
            downloadCSV(response.data,'data');
            setIsErrApiLoading(false);
         }).catch(error=>{
            setIsErrApiLoading(false);
            console.log(error);
         })
    }
    
    const error = <Popup
                        content={
                            <div>
                                <div className="MinimumErrors"><u>Errors</u></div>
                                    <List as="ol" className="MinimumErrors">
                                        {isMinimumFields.validFields.map(field=>{
                                            if(!field.isValid){
                                                return (
                                                    <List.Item as='li'>{field.text}</List.Item>
                                                )
                                            }
                                            return ''
                                        })}
                                    </List>
                            </div>
                        }
                        wide='very'
                        position='top center'
                        trigger={
                            <Icon size='large' className='fa-solid fa-triangle-exclamation WarningRed' />
                        }
                        open
                    />

    const BackButton = (currentStep > 0) ? <Button basic className="back-button" onClick={goToPreviousStep}>Back</Button> : null;
    const DownloadButton = import_results?.rejected ? <Button basic color='red' onClick={downloadErrfile} loading={isErrApiLoading} disabled={isErrApiLoading}>Download error file</Button> : null;

    return (
        <SettingsFooter
            style={{ width: width }}
            className={`Webform__menu`}
            rightOptions={[
                    ((!isMinimumFields.isValid && currentStep > 0) && error),
                    currentStep < STEPS.length - 1 && <Button className="cancel-button" as={Link} to='/settings/import-data' basic>Cancel</Button>,
                    <Button primary loading={isAddingImport} onClick={goToNextStep} disabled={(!isNextStepEnabled())} color={(!isNextStepEnabled()) ? 'black' : 'primary'}>
                                {customStep || (currentStep < STEPS.length - 1 ? 'Next' : 'Done')}
                            </Button>,
            ]}
            leftOptions={currentStep < STEPS.length - 1 ?  [
                BackButton,
            ] : [DownloadButton]}
        />
    );
};
